import React from "react"
import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { Product } from "@shopify/hydrogen-react/storefront-api-types"

import Icon from "@app/components/Icon"

type Props = {
  handleMinusClick: () => void
  handlePlusClick: () => void
  product?: Product
  quantity: number
}

export const ProductStockQuantitySelector: React.FC<Props> = React.memo(({ handleMinusClick, handlePlusClick, product, quantity }) =>
  !/gift/.test(product?.handle || "") ? (
    <Box display="inline-block" textAlign="center">
      <Flex justifyContent="flex-start" alignItems="center" mx="auto">
        <Button
          variant="transparent"
          onClick={handleMinusClick}
          aria-label="Decrease Quantity"
          title="Decrease Quantity"
          display="flex"
          justifyContent="center"
          alignItems="center"
          w={5}
        >
          <Icon name="minus" width="8px" height="auto" pointerEvents="none" />
        </Button>
        <Box pos="relative" minW="30px" pt={1} pb={2}>
          <Text variant="text15">{quantity}</Text>
        </Box>
        <Button
          variant="transparent"
          onClick={handlePlusClick}
          aria-label="Increase Quantity"
          title="Increase Quantity"
          display="flex"
          justifyContent="center"
          alignItems="center"
          w={5}
        >
          <Icon name="plus" width="8px" height="auto" pointerEvents="none" />
        </Button>
      </Flex>
    </Box>
  ) : null
)
